<template>
  <b-container>
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template>
    <b-row v-if="!isLoading">
      <b-col class="my-4">
        <div class="main-banner">
          <img
            :src="
              (marketBannerImage.icon && marketBannerImage.icon.fileUrl) || ''
            "
            alt="Healthcare Market Banner"
          />
        </div>
        <span class="text-grey1">Order Medicine > Search Specific Item </span>
        <sections-slider
          v-if="list && list.length"
          :list="list"
          subTitle="Health Care"
          :hasInnerBackground="true"
          :hasButton="false"
          :withSlider="true"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box">
              <items-item
                :itemLogo="true"
                :product="listItem"
                :incrementDecrementKey="false"
                :marketRoute="{
                  name:
                    'healthcare-product-list',
                  params: {
                    market: listItem.name,
                    id: listItem._id,
                    items: listItem.externalAttributes,
                  },
                }"
              ></items-item>
            </div>
          </template>
        </sections-slider>
        <sections-slider
          :list="itemSuggestions"
          subTitle="Most Popular"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Most Popular`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
        <sections-slider
          :list="newArrivals"
          subTitle="Daily Essentials"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Daily Essentials`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      allCategories: (state) => state.healthCare.healthCareCategories,
      list: (state) => state.healthCare.specificItems,
      itemSuggestions: (state) => state.healthCare.itemSuggestions,
      newArrivals: (state) => state.healthCare.newArrivals,
      marketBannerImage: (state) => state.healthCare.marketBanner,
    }),
  },
  methods: {},

  async mounted() {
    this.isLoading = true;
    let payload = {
      city: "GHATAL",
      placement: "MARKET_TOP",
      market: this.$route.params.marketid,
    };
    await this.$store.dispatch("healthCare/fetchMarketBanner", payload);
    await this.$store.dispatch(
      "healthCare/fetchAllItems",
      this.$route.params.market
    );
    await this.$store.dispatch(
      "healthCare/fetchSpecificItems",
      this.$route.params.categoryid
        ? this.$route.params.categoryid
        : this.allCategories[0]._id
    );
    this.isLoading = false;
  },

  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.text-grey1 {
  color: #aaa;
  background-color: transparent;
  margin: 0px 10px;
}
.main-banner {
  border-radius: 8px;
  margin-bottom: 20px;
}
.main-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>
